import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import {
  DirectLinkDetailsService,
  directLinkDetails,
} from '../direct-link-details.service';

export interface ExpireDirectLinkResponse {
  isSuccess: boolean;
  error: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthDirectLinkDetailsService {
  complete: boolean = false;
  endPointBase: string =
    '/DirectLinkDetails/AuthenticatedDirectLinkDetailsAsync';
  expireEndPointBase: string = '/DirectLinkDetails/ExpireDirectLink';

  private http = inject(HttpClient);
  private directLinkDetailsService = inject(DirectLinkDetailsService);

  directLinkDetails: directLinkDetails = {
    isSuccess: false,
    error: '',
    clientId: '',
    billingGroupId: '',
    guarantorId: 0,
    chargeId: 0,
    destination: '',
    paymentsOnPatientDeviceDataID: 0,
    directLinkId: 0,
    autoAuthDay: '',
    autoAuthMonth: '',
    autoAuthYear: '',
    redirectURL: '',
    siteUrl: '',
  };

  expireResponse: ExpireDirectLinkResponse = {
    isSuccess: false,
    error: '',
  };

  private directLinkDetailsSubject =
    new BehaviorSubject<directLinkDetails | null>(null);
  directLinkDetails$ = this.directLinkDetailsSubject.asObservable();

  private expireResponseSubject = new BehaviorSubject<directLinkDetails | null>(
    null
  );
  expireResponse$ = this.expireResponseSubject.asObservable();

  fetch() {
    this.complete = false;
    this.http
      .post<directLinkDetails>(
        environment.apiUrl + this.endPointBase,
        {},
        {
          observe: 'response',
        }
      )
      .subscribe({
        next: (res: HttpResponse<directLinkDetails>) => {
          if (res.status === 200 && res.body) {
            this.directLinkDetails = res.body;
            this.directLinkDetailsSubject.next(res.body);
            this.directLinkDetailsService.setDirectLinkDetails(res.body);
            if (res && res.body) {
              this.complete = true;
            }
          }
        },
      });
  }

  expireDirectLink() {
    this.http
      .post<directLinkDetails>(
        environment.apiUrl + this.expireEndPointBase,
        {},
        {
          observe: 'response',
        }
      )
      .subscribe({
        next: (res: HttpResponse<directLinkDetails>) => {
          if (res.status === 200 && res.body) {
            this.expireResponse = res.body;
            this.expireResponseSubject.next(res.body);
          }
        },
      });
  }
}
